/* ============================================================
   CITADEL HEALTH — cart-drawer.js
   Simple version: no Section Rendering API, no sections= param.
   Calls plain /cart/change.js, then patches quantity, line price,
   cart subtotal/total, AND the free-shipping bar (width + message)
   directly in the DOM from the JSON response.

   The shipping threshold and message templates come from theme
   settings via data-attributes rendered by Liquid onto #cd-ship
   (data-ship-limit-cents, data-ship-msg-before, data-ship-msg-after),
   so the JS math always matches what Liquid would have rendered.
   ============================================================ */

(function () {
  var ROOT_SELECTOR = '#cart-drawer-root';

  function getRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function setPending(itemEl, isPending) {
    if (!itemEl) return;
    itemEl.classList.toggle('cd-item--pending', isPending);
    var btns = itemEl.querySelectorAll('.cd-qty__btn, .cd-item__remove');
    btns.forEach(function (btn) {
      btn.disabled = isPending;
    });
  }

  // Renumber data-line attributes after a removal, since Shopify's
  // /cart/change.js uses 1-based line position and removing a line
  // shifts every line after it up by one.
  function renumberLines() {
    var root = getRoot();
    if (!root) return;
    var items = root.querySelectorAll('.cd-item');
    items.forEach(function (item, idx) {
      var line = idx + 1;
      item.setAttribute('data-line', line);
      var qtyWrap = item.querySelector('.cd-qty');
      if (qtyWrap) qtyWrap.setAttribute('data-line', line);
      var removeBtn = item.querySelector('.cd-item__remove');
      if (removeBtn) removeBtn.setAttribute('data-line', line);
    });
  }

  function patchTotals(cart) {
    var root = getRoot();
    if (!root) return;

    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var totalEl = root.querySelector('[data-cart-total]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    patchShippingBar(cart);
  }

  // Mirrors the Liquid calculation in citadel-cart-drawer.liquid:
  //   free_limit = settings.cart--shipping-limit * 100
  //   if cart.total_price >= free_limit -> 100%, "after" message
  //   else -> percentage filled, "before" message with [$] replaced
  //           by the remaining amount needed
  function patchShippingBar(cart) {
    var shipEl = document.getElementById('cd-ship');
    if (!shipEl) return; // shipping bar not enabled for this store

    var limitCents = parseInt(shipEl.getAttribute('data-ship-limit-cents'), 10);
    if (!limitCents) return;

    var msgBefore = shipEl.getAttribute('data-ship-msg-before') || '';
    var msgAfter = shipEl.getAttribute('data-ship-msg-after') || '';
    var msgEl = document.getElementById('cd-ship-msg');
    var fillEl = document.getElementById('cd-ship-fill');

    var total = cart.total_price;
    var barWidth;
    var message;

    if (total >= limitCents) {
      barWidth = 100;
      message = msgAfter;
    } else {
      barWidth = (total / limitCents) * 100;
      var remaining = limitCents - total;
      message = msgBefore.replace('[$]', formatMoney(remaining));
    }

    if (fillEl) fillEl.style.width = barWidth + '%';
    if (msgEl) msgEl.textContent = message;
  }

  function patchLine(itemEl, line) {
    if (!itemEl || !line) return;
    var qtyEl = itemEl.querySelector('[data-qty-value]');
    var priceEl = itemEl.querySelector('[data-line-price]');
    if (qtyEl) qtyEl.textContent = line.quantity;
    if (priceEl) priceEl.textContent = formatMoney(line.final_line_price);
  }

  function formatMoney(cents) {
    // Uses Shopify.currency if present (set in theme.liquid), otherwise
    // falls back to a plain decimal — good enough for most single-currency stores.
    var amount = (cents / 100).toFixed(2);
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return amount + ' ' + window.Shopify.currency.active;
    }
    return '$' + amount;
  }

  function removeItem(itemEl) {
    if (!itemEl) return;
    itemEl.classList.add('cd-item--removing');
    setTimeout(function () {
      itemEl.remove();
      renumberLines();
      maybeShowEmptyState();
    }, 260);
  }

  function maybeShowEmptyState() {
    var root = getRoot();
    if (!root) return;
    var list = root.querySelector('#cd-list');
    if (list && list.children.length === 0) {
      // Simplest correct option without rebuilding the empty-state markup
      // in JS: reload once the cart is actually empty, so Liquid renders
      // the proper empty state, empty-state links, etc.
      location.reload();
    }
  }

  function changeLine(line, quantity, itemEl, isRemove) {
    setPending(itemEl, true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed (' + res.status + ')');
        return res.json();
      })
      .then(function (cart) {
        patchTotals(cart);

        if (isRemove) {
          removeItem(itemEl);
          return;
        }

        var updatedLine = cart.items[line - 1];
        if (updatedLine) {
          patchLine(itemEl, updatedLine);
        }
        setPending(itemEl, false);
      })
      .catch(function (err) {
        console.error('[cart-drawer]', err);
        setPending(itemEl, false);
      });
  }

  function handleQtyClick(e) {
    var btn = e.target.closest('.cd-qty__btn');
    if (!btn) return;

    var wrap = btn.closest('.cd-qty');
    var itemEl = btn.closest('.cd-item');
    if (!wrap || !itemEl) return;

    var line = parseInt(wrap.getAttribute('data-line'), 10);
    var valEl = wrap.querySelector('.cd-qty__val');
    var current = parseInt(valEl.textContent, 10) || 1;
    var dir = parseInt(btn.getAttribute('data-dir'), 10);
    var next = current + dir;

    if (next < 1) return; // use Remove to go to 0, avoids accidental delete on a stray click

    changeLine(line, next, itemEl, false);
  }

  function handleRemoveClick(e) {
    var btn = e.target.closest('.cd-item__remove');
    if (!btn) return;

    var itemEl = btn.closest('.cd-item');
    var line = parseInt(btn.getAttribute('data-line'), 10);
    changeLine(line, 0, itemEl, true);
  }

  function delegatedClick(e) {
    if (e.target.closest('.cd-qty__btn')) {
      handleQtyClick(e);
      return;
    }
    if (e.target.closest('.cd-item__remove')) {
      handleRemoveClick(e);
      return;
    }
  }

  function bindEvents() {
    var root = getRoot();
    if (!root) return;
    root.removeEventListener('click', delegatedClick);
    root.addEventListener('click', delegatedClick);
  }

  document.addEventListener('DOMContentLoaded', bindEvents);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    bindEvents();
  }
})();